import { RightOutlined } from "@ant-design/icons";
import { Col, List, Row, Segmented, Skeleton, Space, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "../ServerSideStates";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { getNearbyPlaces } from "../Services";
import CustomNoData from "apps/Common/CustomNoData";

const NearByLocations = () => {
  const { Text } = Typography;
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(advertId);

  const [placeList, setPlaceList] = useState<any[]>([]);
  const getNearPlaceList = async (data: any) => {
    setIsLoading(true);
    try {
      const response = await getNearbyPlaces(data);
      if (response?.data) {
        setPlaceList(response?.data);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (advertDetails?.data) {
      const advertData = advertDetails?.data?.data;
      if (advertData?.latitude && advertData?.longitude) {
        let locatiion = {
          lat: advertData?.latitude,
          lng: advertData?.longitude,
        };
        getNearPlaceList(locatiion);
      }
    }
  }, [advertDetails.data]);

  return (
    <>
    {
      placeList?.length>0&&
      <Col span={24}>
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <Text className="!text-xl !font-bold">Yakında Neler Var?</Text>
          </Col>
          <Skeleton loading={isLoading}>
          <>
                <Col xs={24}>
                  <Row gutter={[20, 20]}>
                    <Col span={24}>
                      <List
                        header={false}
                        footer={false}
                        bordered
                        dataSource={placeList}
                        renderItem={(item) => (
                          <List.Item className="!flex justify-between">
                            <div>
                              <Space>
                             
                                <Text>{item.place}</Text>
                              </Space>
                            </div>
                            <div>
                              <Space>
                                <Text>{item.distance}</Text>
                                <RightOutlined />
                              </Space>
                            </div>
                          </List.Item>
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
              </>
          </Skeleton>
        </Row>
      </Col>
    }

    </>
  );
};

export default NearByLocations;
